import axios from "axios";

export const getAllActivityType = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/activity-type/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener los tipos de actividad";
  }
};

export const createActivityTypeService = async (userData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token provided");
  try {
    const { data } = await axios.post(`${API_URL}/api/activity-type`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear tipo de actividad");
  }
};

export const updateActivityTypeService = async (id, userData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(`${API_URL}/api/activity-type/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al actualizar tipo de actividad";
  }
};

export const deleteActivityTypeService = async (userId) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No hay token de autenticación");
  }

  try {
    const response = await axios.delete(`${API_URL}/api/activity-type/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error al marcar el tipo de actividad como eliminado";
    throw new Error(errorMessage);
  }
};
